import * as i0 from '@angular/core';
import { Injectable, ViewChild } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { getStepDetails, updateStepStatus } from 'visa-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as errorUtils from 'error-message-utility';
import * as i2 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'cache-country-list';
import * as i6 from 'app-services-library';

class APIConsulateAddress {
    constructor(http) {
        this.http = http;
    }
    getConsulatesAddress(visatype, caseType, caseId) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/consulates`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return [];
            }
        }));
    }
    getBeneficiaryAddress(beneficiaryId) {
        return this.http.get(`/analysis/petition/${beneficiaryId}/beneficiary`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getConsulatesAddressByCountryCode(visatype, caseType, caseId, countryCode) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/country/${countryCode}/consulates`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return [];
            }
        }));
    }
    postProcessingInformation(visatype, caseType, caseId, consulateAddressId, payload) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/consulate/${consulateAddressId}/update`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getDirectFilingAddress(visatype) {
        return this.http.get(`/addresslink/${visatype}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return [];
            }
        }));
    }
}
APIConsulateAddress.ɵfac = function APIConsulateAddress_Factory(t) { return new (t || APIConsulateAddress)(i0.ɵɵinject(i1.HttpClient)); };
APIConsulateAddress.ɵprov = i0.ɵɵdefineInjectable({ token: APIConsulateAddress, factory: APIConsulateAddress.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIConsulateAddress, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseConsulateAddressLibraryService {
    constructor(store, toastr, apiService, stepStatusUpdatePayloadCostruction, cacheCountryService, appServicesLibraryService) {
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.cacheCountryService = cacheCountryService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.typeOfOffice = null;
        this.prevTypeOfOffice = null;
        this.listCountry = [];
        this.directFilingAddress = '';
        this.observableSubscription$ = new Subject();
        this.officeAddressCity = '';
        this.usStateOrForiegnCountry = '';
        this.officeTypeOptions = [
            {
                name: 'Consulate',
                value: 'Consulate'
            },
            {
                name: 'Pre-flight Inspection',
                value: 'Pre-flight Inspection'
            },
            {
                name: 'Port of Entry',
                value: 'Port of Entry'
            },
        ];
        this.beneficiaryAddress = {};
        this.disabledControls = false;
        this.selectedConsulateAddress = null;
        this.consulateAddress = [];
    }
    loadInit() {
        this.getFilingAddress();
        console.log('RRRRR', this.inputData);
        if (this.isWizardFalg) {
            this.getConsulateAddress();
            //this.toggleControlsStatus();
            this.getBeneficiaryAddress();
        }
        else {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.stepDetails = data;
                this.getConsulateAddress();
                this.toggleControlsStatus();
                this.getBeneficiaryAddress();
            });
        }
        this.cacheCountryService.getCountryWithoutUSA().subscribe(data => {
            if (data && data.length > 0) {
                this.listCountry = data;
            }
            else {
                this.listCountry = [];
            }
        });
        this.typeOfOffice = {
            value: '',
            name: ''
        };
        this.prevTypeOfOffice = JSON.parse(JSON.stringify(this.typeOfOffice));
    }
    loadAfterViewInit() {
        this.processingInformationForm.form.valueChanges.pipe(map(() => this.processingInformationForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    getBeneficiaryAddress() {
        this.apiService.getBeneficiaryAddress(this.inputData.petitionId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.data) {
                this.beneficiaryAddress = JSON.parse(response.data);
            }
        });
    }
    officeTypeToggle(typeOfOffice) {
        if (this.prevTypeOfOffice.value === typeOfOffice.value) {
            this.typeOfOffice = {
                value: '',
                name: ''
            };
            this.prevTypeOfOffice = JSON.parse(JSON.stringify(this.typeOfOffice));
        }
        else {
            this.prevTypeOfOffice = JSON.parse(JSON.stringify(typeOfOffice));
        }
    }
    onRowSelect(event) {
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
        }));
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    getConsulateAddress() {
        this.apiService.getConsulatesAddress(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response['data']) {
                this.typeOfOffice = this.officeTypeOptions.find(x => x.value === response['data'].typeOfOffice);
                this.prevTypeOfOffice = JSON.parse(JSON.stringify(this.typeOfOffice));
                if (this.typeOfOffice.value !== '') {
                    if (this.typeOfOffice.value === 'Consulate') {
                        if (response['data'].petitionConsulateListResponse) {
                            this.consulateAddress = response['data'].petitionConsulateListResponse;
                            this.selectedConsulateAddress = this.consulateAddress.find(x => x['selected'] === true);
                            if (this.selectedConsulateAddress)
                                this.countryCode = this.selectedConsulateAddress.countryCode;
                        }
                    }
                    else {
                        this.officeAddressCity = response['data'].officeAddressCity;
                        this.usStateOrForiegnCountry = response['data'].usStateOrForiegnCountry;
                    }
                }
                else {
                    const typeOfOffice = {
                        value: '',
                        name: ''
                    };
                    this.officeTypeToggle(typeOfOffice);
                }
            }
            else {
                this.consulateAddress = [];
                this.selectedConsulateAddress = null;
                this.officeAddressCity = '';
                this.usStateOrForiegnCountry = '';
            }
        });
    }
    postProcessingInformation() {
        const payload = {
            typeOfOffice: this.typeOfOffice.value,
            officeAddressCity: this.typeOfOffice.value !== '' && this.officeAddressCity !== '' ? this.officeAddressCity : '',
            usStateOrForiegnCountry: this.typeOfOffice.value !== '' && this.usStateOrForiegnCountry !== '' ? this.usStateOrForiegnCountry : '',
        };
        let consulateId = 0;
        if (this.typeOfOffice.value === 'Consulate' && this.selectedConsulateAddress['consulateId']) {
            consulateId = this.selectedConsulateAddress['consulateId'];
        }
        this.apiService.postProcessingInformation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, consulateId, payload).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            this.toastr.success(response.message, 'Success');
            this.processingInformationForm.resetForm();
            this.getConsulateAddress();
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    onChangeCountry() {
        this.apiService.getConsulatesAddressByCountryCode(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.countryCode)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response['data']) {
                this.consulateAddress = response['data'];
                this.selectedConsulateAddress = this.consulateAddress.find(x => x['selected'] === true);
                if (this.selectedConsulateAddress)
                    this.countryCode = this.selectedConsulateAddress.countryCode;
            }
            else {
                this.consulateAddress = [];
                this.selectedConsulateAddress = null;
            }
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    getFilingAddress() {
        this.apiService.getDirectFilingAddress(this.inputData.visatype)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response['data']) {
                this.directFilingAddress = response['data'];
            }
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseConsulateAddressLibraryService.ɵfac = function BaseConsulateAddressLibraryService_Factory(t) { return new (t || BaseConsulateAddressLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(i2.ToastrService), i0.ɵɵinject(APIConsulateAddress), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.CacheCountryListService), i0.ɵɵinject(i6.AppServicesLibraryService)); };
BaseConsulateAddressLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseConsulateAddressLibraryService, factory: BaseConsulateAddressLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseConsulateAddressLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.ToastrService }, { type: APIConsulateAddress }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.CacheCountryListService }, { type: i6.AppServicesLibraryService }]; }, { processingInformationForm: [{
            type: ViewChild,
            args: ['processingInformationForm', { static: true }]
        }] }); })();

/*
 * Public API Surface of base-consulate-address-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIConsulateAddress, BaseConsulateAddressLibraryService };
//# sourceMappingURL=base-consulate-address-library.js.map
